import type { Theme } from '@ori-ui/mui';
import { useMediaQuery } from '@ori-ui/mui';
import { Suspense, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

import { useLazyPersonalMenu } from './useLazyPersonalMenu';

export const usePersonalMenuPortal = () => {
  const isDesktop = useMediaQuery<Theme>((theme) => theme.breakpoints.up(1025));
  const personalMenu = useLazyPersonalMenu();
  const ref = useRef<HTMLElement | null>(null);

  useEffect(() => {
    ref.current = document.getElementById('personal-menu-root');

    return () => {
      ref.current = null;
    };
  }, []);
  if (ref.current && isDesktop) {
    return createPortal(<Suspense>{personalMenu}</Suspense>, ref.current);
  }

  return undefined;
};
